export default __webpack_public_path__ + "static/media/done_wla.67ae6961.png";